var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-wrapper" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [_c("Spinner")], 1)
      : _vm._e(),
    _c("table", { staticClass: "data-table text-sm w-full font-outfit" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSelect,
                  expression: "showSelect",
                },
              ],
              staticClass:
                "bg-lightBlue px-4 py-4 border-b-1 border-gray-200 text-left font-medium",
            }),
            _vm._l(_vm.columns, function (column) {
              return _c(
                "th",
                {
                  key: column.field,
                  staticClass:
                    "bg-lightBlue px-4 py-4 border-b-1 border-gray-200 text-left font-medium relative tb-header",
                },
                [
                  _vm._v(" " + _vm._s(column.label) + " "),
                  column.sort
                    ? _c("span", [
                        _c(
                          "span",
                          {
                            staticClass: "icon-sort",
                            on: {
                              click: function ($event) {
                                return _vm.sortColumn(column.field)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "8",
                                  height: "12",
                                  viewBox: "0 0 8 12",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M7.94188 4.57036L4.21022 0.0960542C4.1034 -0.0320181 3.89773 -0.0320181 3.78978 0.0960542L0.0581151 4.57036C-0.0805157 4.7372 0.0444792 4.9816 0.268334 4.9816H7.73167C7.95552 4.9816 8.08052 4.7372 7.94188 4.57036Z",
                                    fill:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "asc"
                                        ? "none"
                                        : "black",
                                    "fill-opacity": "0.25",
                                    stroke:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "asc"
                                        ? "black"
                                        : "none",
                                    "stroke-width": "0.2",
                                    "stroke-opacity": "0.25",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M7.73167 7.0184H0.268334C0.0444792 7.0184 -0.0805157 7.2628 0.0581151 7.42964L3.78978 11.9039C3.89659 12.032 4.10227 12.032 4.21022 11.9039L7.94188 7.42964C8.08052 7.2628 7.95552 7.0184 7.73167 7.0184Z",
                                    fill:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "desc"
                                        ? "none"
                                        : "black",
                                    "fill-opacity": "0.25",
                                    stroke:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "desc"
                                        ? "black"
                                        : "none",
                                    "stroke-width": "0.2",
                                    "stroke-opacity": "0.25",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            _vm.hasActions
              ? _c("th", {
                  staticClass:
                    "bg-lightBlue px-4 py-4 border-b-1 border-gray-200 text-left font-medium",
                })
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "tbody",
        [
          _vm._l(_vm.data, function (row) {
            return _c(
              "tr",
              { key: row.id, class: _vm.getBodyRowClasses?.(row) },
              [
                _c("td", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSelect,
                      expression: "showSelect",
                    },
                  ],
                  staticClass:
                    "px-4 py-4 border-b-1 border-gray-200 font-normal",
                }),
                _vm._l(_vm.columns, function (column) {
                  return _c(
                    "td",
                    {
                      key: column.field,
                      staticClass: "px-4 py-4 border-b-1 border-gray-200",
                    },
                    [
                      _vm._t(
                        column.field,
                        function () {
                          return [
                            column.field === "project_activity.project.name"
                              ? _c("span", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "cursor-pointer hover:text-badgeBlue",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleProjectClick(row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getRowValue(row, column.field)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getRowValue(row, column.field)
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]
                        },
                        { row: row }
                      ),
                    ],
                    2
                  )
                }),
                _vm.hasActions
                  ? _c(
                      "td",
                      { staticClass: "px-4 py-4 border-b-1 border-gray-200" },
                      [_vm._t("actions", null, { row: row })],
                      2
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          !_vm.data.length
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "px-4 py-4 border-b-1 border-gray-200 text-center text-gray-500",
                    attrs: {
                      colspan:
                        _vm.columns.length +
                        (_vm.showSelect ? 1 : 0) +
                        (_vm.hasActions ? 1 : 0),
                    },
                  },
                  [_vm._v(" No data available ")]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }